import { Modal } from 'lib/mortar/components/Modal';
import { track } from 'lib/sdks/analytics';
import { useRouter } from 'next/router';
import { useLocalStorage } from '@hooks/use-local-storage';

import JobSummary from './screens/JobSummary';

import Header from './components/Header';
import { useJobRefinementState, HIDE_SUMMARY } from './JobRefinement.reducer';
import type { Address } from './types';
import { getTransformedJobBlob } from './utils';

const nextPage = '/message/contact-information';

const JobSummaryModal = ({ disableDismiss }: { disableDismiss?: boolean }) => {
  const router = useRouter();
  const [address] = useLocalStorage<Address>('address');
  const [, setJobLocalStorage] = useLocalStorage('job', {});
  const { state, dispatch } = useJobRefinementState();

  const {
    showSummary,
    category,
    showJobRefinementModal,
    origin = 'search',
  } = state;

  const handleSubmit = () => {
    if (origin !== 'pre-select') {
      track('job.message_submit', { categoryId: category?.id });

      const jobBlob = getTransformedJobBlob(state, address);
      setJobLocalStorage(jobBlob);

      return router.push(nextPage);
    }
  };

  const onDismissSummary = () => {
    dispatch({ type: HIDE_SUMMARY });
  };

  if (!showSummary || showJobRefinementModal) return null;
  return (
    <Modal
      size="medium"
      className="!min-h-[75vh] px-4 py-6 sm:!max-h-[75vh] sm:px-8"
      fullScreenOnMobile
      name="Job Refinement Summary"
      noPadding
      hideCloseButton
      onDismiss={onDismissSummary}
      closeOnClickOutside={!disableDismiss}
    >
      <Header onCancel={onDismissSummary} disableDismiss={disableDismiss} />
      <JobSummary onNext={handleSubmit} />
    </Modal>
  );
};

export default JobSummaryModal;
